import React, { useEffect } from "react";
import { Box, Grid, Tooltip, Stack, Chip, Button, IconButton, Typography, useTheme, Divider, TextField, Switch } from "@mui/material";
import TextareaAutosize from '@mui/material/TextareaAutosize';

import { useQuery } from "@tanstack/react-query";
//Hooks
import { getTransportCompanies } from "../../../hooks/transportCompanies";
import { getFreightCost } from "../../../hooks/freight";
//Controls
import AxionControls from "../../../components/controls/AxionControls";
import { pushErrorMessage, pushNotification } from "../../../utils/notifications";
//Icons
import LocationOnIcon from '@mui/icons-material/LocationOn';

import { tokens } from "../../../assets/theme";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import messages from "../messages";
import { useLocalStorage } from "../../../hooks/useLocalStorage";
import { replace } from "react-router-dom";

const PickupDetails = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const states = [1, 2, 3, 4, 9];
    const stateNames = ["Regitered", "In progress", "Pick up", "Paid", "Ready"];
    const statesCount = [];
    const [filteredData, setfilteredData] = useState([]);
    const [searchValue, setSearchValue] = useState("");
    const [stateValue, setStateValue] = useState("");
    const [showChildrenFor, setShowChildrenFor] = useState(0);
    const [ldmCalculated, setLdmCalculated] = useState(false);
    const craneCost = 4000;
    //const [instanceGermany, setInstanceGermany] = useLocalStorage("InstanceGermany", false);
    const [instanceCountry, setInstanceCountry] = useLocalStorage("instanceCountry", "SV");


    // useEffect(() => {
    //     calcTransportCost();
    // }, [props.data?.pickupdata?.location, props.data?.pickupdata?.loadingmeters]);

    const transportCompaniesQuery = useQuery(
        ["transportCompanies"],
        () => getTransportCompanies(),
        {}
    );

    const handlePickupdataNeedhiabChange = (event) => {
        // let orderData = {...props.data};
        // orderData.pickupdata.needhiab = event.target.checked;
        // props.setShowOrder(orderData);
        if (event.target.checked) {
            props.addFreightCost(4000);
        } else {
            props.addFreightCost(-4000);
        }
        props.handleChange(event);
    };

    const handlePickupdataLiftingdeviceChange = (event) => {
        // let orderData = {...props.data};
        // orderData.pickupdata.pickuptime = event.target.value;
        // props.setShowOrder(orderData);

        event.target.checked = event.target.checked ? 1 : 0;
        props.handleChange(event);
    }

    const handlePickupdataPickupBookedChange = (event) => {

        console.log("Pickup booked: ", event.target.checked);

        event.target.value = event.target.checked ? 3 : 1;

        console.log("Pickup booked after: ", event.target);
        props.handleChangeSetValue(event);
    }

    const handletransportCompanyChange = (event, id) => {
        console.log("Transport company: ", event.target);
        event.target.id = id;
        props.handleChange(event);
    }

    function getTransportCompanyOptions() {

        var companyList = transportCompaniesQuery.data || [];
        var companies = companyList.sort((a, b) => (a.name > b.name) ? 1 : -1).map((item, index) => { return { id: item.id, title: item.name, sortorder: index } });
        return companies || [];
    }

    function calcTransportCost(cost, crane) {
        if (cost === null || cost === undefined || cost === "") {
            return "";
        }
        if (crane) {
            cost = parseInt(cost) + parseInt(craneCost);
        }
        return cost;
    }

    function calcLdmNonstacked(status) {
        let ldm = 0;

        if (status >= 3) {
            return "";
        }
        props.data?.returndrums?.forEach(row => {
            //console.log(row.article.description, row.drumcount, row.article.stackedWreightweight);
            if (row.article === null || row.article === undefined) {
                return;;
            }
            ldm += row.drumcount * row.article?.wreightweight / 1850;

        });

        if (ldm === 0 && props.data?.returndrums?.length > 0) {
            return "";
        }

        return " (Not stacked: " + Math.round(ldm * 100) / 100 + " ldm]";
    }

    function calcLdmStacked() {
        let ldm = 0;
        props.data?.returndrums?.forEach(row => {
            //console.log(row.drumcount, row.article);

            if (row.article === null || row.article === undefined) {
                return;
            }
            ldm += row.drumcount * row.article?.stackedWreightweight / 1850;
        });

        if (ldm === 0 && props.data?.returndrums?.length > 0) {
            return "Can't be calculated";
        }

        return Math.round(ldm * 100) / 100 + " ldm";
    }

    function calcWeight() {
        let weight = 0;
        props.data?.returndrums?.forEach(row => {
            if (row.article === null || row.article === undefined) {
                return;
            }
            //console.log(row.article.description, row.drumcount, row.article?.stackedWreightweight);
            weight += row.drumcount * row.article?.weight;
        });
        if (weight === 0 && props.data?.returndrums?.length > 0) {
            return "Can't be calculated";
        }
        return Math.round(weight * 100) / 100 + " kg";
    }

    // function calcTransportCost() {

    //     var address = props.data?.pickupdata?.location;
    //     var zip = address.split(',')[1].trim();

    //     var ldm = props.data?.pickupdata?.loadingmeters;

    //     if (zip === null || zip === undefined || ldm === null || ldm === undefined) {   
    //         return;
    //     }

    //     getFreightCost(zip, props.data?.pickupdata?.loadingmeters).then((result) => {
    //         console.log("Freight cost: ", result, zip, ldm);
    //         if (result === null || result === undefined) {
    //             return;
    //         }
    //         props.data.pickupdata.transportCost = result;
    //         //props.setShowOrder(props.data);
    //     });
    // }

    function calculateFreight() {
        let freight = 0;
        if (props.data?.returnType === 2) {
            if (props.data?.returndrums?.filter(x => x.article.itemNo === "780000011")?.length > 0) {
                freight = 150; // aktual freightcost should be on the freight cost article
            }
        }
        if (props.data?.returnType === 1) {
            freight = props.data?.returndrums?.filter(x => x.article.itemNo === "780000000")[0]?.drumcount || 0;
        }

        return freight;
    }


    if (props.data === null) {
        return <Box color="white">Data is missing...</Box>;
    }

    if (transportCompaniesQuery.isLoading) {
        return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}><img width="50px" height="50px" src="../../../assets/axion_spinner_white.gif" alt="ddd"></img></div>;
    }



    //console.log ("TransportCompanies: ", transportCompaniesQuery.data);
    //console.log("Pickup details...Data: ", props.data);
    //console.log("instanceGermany", instanceGermany);


    let content = <>
        <Box color={colors.primary[100]}>

            <Grid container alignItems="center" width="100%" height="600px" direction="row" spacing="auto" padding="10px">
                <><Grid item xs={4} height="30px">
                    <Stack direction="row" display="flex" alignItems="center">
                        <Typography><FormattedMessage {...messages.pickupDetails_pickupPoint} /></Typography>
                        <Tooltip title={<Typography fontSize="12px"><FormattedMessage {...messages.pickupDetails_locationOnMap} />Show location om map (Opens in a new tab)</Typography>}>
                            <IconButton href={'https://www.google.com/maps/preview?q=' + props.data?.pickupdata?.lat + ',' + props.data?.pickupdata?.lng} target="_blank"><LocationOnIcon /></IconButton>
                        </Tooltip>
                    </Stack>
                </Grid>
                    <Grid item xs={8}>
                        <Stack direction="row" display="flex" alignContent="center" alignItems="center">
                            <AxionControls.AxionTextBox name="pickupdata.location" id="pickupdata.location" label="" value={props.data?.pickupdata?.location} sx={{ minWidth: '100%' }} onChange={props.handleChange} />
                        </Stack>
                    </Grid>
                    <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                    <Grid item xs={4}><Typography><FormattedMessage {...messages.pickupDetails_additionalServices} /></Typography></Grid>
                    <Grid item xs={8}>
                        <AxionControls.AxionTextBox name="pickupdata.services" id="pickupdata.services" label="" value={props.data?.pickupdata?.services} sx={{ minWidth: '100%' }} onChange={props.handleChange} />
                        {/* <AxionControls.AxionTextBox id="pickupdata.services" label="" value={props.data?.pickupdata?.services} sx={{ minWidth: '50%' }} onChange={props.handleChange} /> */}
                    </Grid>
                    <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                    <Grid item xs={4}><Typography><FormattedMessage {...messages.pickupDetails_contact} /></Typography></Grid>
                    <Grid item xs={8}>
                        <AxionControls.AxionTextBox name="pickupdata.contact" id="pickupdata.contact" label="" value={props.data?.pickupdata?.contact} sx={{ minWidth: '50%' }} onChange={props.handleChange} />
                        {/* <AxionControls.AxionTextBox id="pickupdata.contact" label="" value={props.data?.pickupdata?.contact} sx={{ minWidth: '50%' }} onChange={props.handleChange} /> */}
                    </Grid>
                    <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                    <Grid item xs={4}><Typography><FormattedMessage {...messages.pickupDetails_phoneNumber} /></Typography></Grid>
                    <Grid item xs={8}>
                        <AxionControls.AxionTextBox name="pickupdata.phonenumber" id="pickupdata.phonenumber" label="" value={props.data?.pickupdata?.phonenumber} sx={{ minWidth: '50%' }} onChange={props.handleChange} />
                        {/* <AxionControls.AxionTextBox id="pickupdata.phonenumber" label="" value={props.data?.pickupdata?.phonenumber} sx={{ minWidth: '50%' }} onChange={props.handleChange}/> */}
                    </Grid>
                    <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                    <Grid item xs={4}><Typography><FormattedMessage {...messages.pickupDetails_craneTruck} /></Typography></Grid>
                    <Grid item xs={8}><Switch checked={props.data?.pickupdata?.needhiab} onChange={handlePickupdataNeedhiabChange} id="pickupdata.needhiab" />{props.data?.pickupdata?.needhiab ? "Yes" : "No"}</Grid></>
                {/* <Grid item xs={8}><Typography>{props.data?.pickupdata.liftingdevice}</Typography></Grid> */}
                <><Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                    <Grid item xs={4}><Typography><FormattedMessage {...messages.pickupDetails_liftingDevice} /></Typography></Grid>
                    <Grid item xs={8}><Typography><Switch checked={props.data?.pickupdata?.liftingdevice} onChange={handlePickupdataLiftingdeviceChange} id="pickupdata.liftingdevice" />{props.data?.pickupdata?.liftingdevice ? "Yes" : "No"}</Typography></Grid>
                </>
                {/* <Grid item xs={8}><Typography><Switch/>{props.data?.pickupdata.needhiab.toString()} [needhiab???]</Typography></Grid> */}

                <><Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                    <Grid item xs={4}><Typography><FormattedMessage {...messages.pickupDetails_pickupTime} /></Typography></Grid>
                    <Grid item xs={8}>
                        <AxionControls.AxionTextBox name="pickupdata.pickuptime" id="pickupdata.pickuptime" label="" value={props.data?.pickupdata?.pickuptime} sx={{ minWidth: '50%' }} onChange={props.handleChange} />
                        {/* <AxionControls.AxionTextBox id="pickupdata.pickuptime" label="" value={props.data?.pickupdata?.pickuptime} sx={{ minWidth: '50%' }} onChange={props.handleChange} /> */}
                    </Grid>
                    <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                </>
                <Grid item xs={4}><Typography><FormattedMessage {...messages.pickupDetails_information} /></Typography></Grid>
                <Grid item xs={8}>
                    <TextareaAutosize
                        minRows={2}
                        value={props.data?.pickupdata?.information.replaceAll("<br />", "\n")}
                        style={{ minWidth: '100%' }}
                        onChange={props.handleChange}
                        name="pickupdata.information"
                        id="pickupdata.information"
                    >

                    </TextareaAutosize>
                    {/* <AxionControls.AxionTextBoxMultiline name="pickupdata.information" id="pickupdata.information" label="" value={props.data?.pickupdata?.information.replaceAll("<br />", "\n")} sx={{ minWidth: '100%' }} onChange={props.handleChange} /> */}
                    {/* <AxionControls.AxionTextBox id="pickupdata.information" label="" value={props.data?.pickupdata?.information} sx={{ minWidth: '100%' }} onChange={props.handleChange} /> */}
                </Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={4}><Typography><FormattedMessage {...messages.pickupDetails_pickupBooked} /></Typography></Grid>
                <Grid item xs={8}><Switch id="statusid" checked={props.data?.statusid.toString() === "3"} onChange={handlePickupdataPickupBookedChange} /></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={4}><Typography><FormattedMessage {...messages.pickupDetails_loadingMeters} /></Typography></Grid>
                <Grid item xs={8}><Typography>{props.data?.pickupdata?.loadingmeters} ldm {calcLdmNonstacked(props.data?.statusid)}</Typography></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                <Grid item xs={4}><Typography><FormattedMessage {...messages.pickupDetails_weight} /></Typography></Grid>
                <Grid item xs={8}><Typography>{props.data?.pickupdata?.weight} kg</Typography></Grid>
                {instanceCountry !== "DE" && <>
                    <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                    <Grid item xs={4}><Typography><FormattedMessage {...messages.pickupDetails_freight} /></Typography></Grid>
                    <Grid item xs={8}>
                        {/* <AxionControls.AxionTextBox name="pickupdata.transportCost" id="pickupdata.transportCost" label="" value={props.data?.pickupdata?.transportCost} sx={{ minWidth: '50%' }} onChange={props.handleChange} disabled={props.data?.statusid >= 3} /> */}
                        {calculateFreight()} 
                        {/* calcTransportCost(props.data?.pickupdata?.transportCost, props.data?.pickupdata?.needhiab) */}
                    </Grid>
                </>}
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>
                {/* <Grid item xs={4}><Typography>Transport company</Typography></Grid>
                <Grid item xs={8}><Typography>{props.data?.pickupdata?.transportCompany?.name}</Typography></Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid> */}
                <Grid item xs={4}><Typography><FormattedMessage {...messages.pickupDetails_transportCompany} /></Typography></Grid>
                <Grid item xs={8}>
                    <AxionControls.AxionSelect id="pickupdata.transportCompanyId" name="pickupdata.transportCompanyId" label=""
                        //label={formatMessage(messages.typeOfDrum)} 
                        value={props.data?.pickupdata?.transportCompanyId || ''}
                        options={getTransportCompanyOptions()} sx={{ width: '320px' }}
                        onChange={(event) => handletransportCompanyChange(event, "pickupdata.transportCompanyId")}
                        //onChange={props.handleChange}
                        disabled={props.data?.statusid >= 3}
                    />
                </Grid>
                <Grid item xs={12}><Divider color={colors.primary[900]} /></Grid>


            </Grid>
        </Box>
    </>;

    return (
        <>
            {content}
        </>
    )
};

export default PickupDetails;
